// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Rotate = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Rotate = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Rotate = _exports.Rotate = function Rotate(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.0717 10.9009C17.6234 15.0192 14.1533 18.125 10 18.125C7.16917 18.125 4.58667 16.6492 3.125 14.3217V16.6667C3.125 17.0117 2.845 17.2917 2.5 17.2917C2.155 17.2917 1.875 17.0117 1.875 16.6667V12.5C1.875 12.155 2.155 11.875 2.5 11.875H6.66667C7.01167 11.875 7.29167 12.155 7.29167 12.5C7.29167 12.845 7.01167 13.125 6.66667 13.125H3.8916C5.04993 15.3967 7.3975 16.875 10 16.875C13.5142 16.875 16.4492 14.2483 16.8292 10.7658C16.8659 10.4216 17.1775 10.1758 17.5175 10.2116C17.8617 10.2491 18.1084 10.5575 18.0717 10.9009ZM17.5 2.70833C17.155 2.70833 16.875 2.98833 16.875 3.33333V5.6783C15.4133 3.3508 12.8308 1.875 10 1.875C5.8475 1.875 2.37747 4.98079 1.9283 9.09912C1.8908 9.44245 2.13836 9.75091 2.48169 9.78841C2.50419 9.79091 2.52755 9.79167 2.55005 9.79167C2.86505 9.79167 3.1358 9.55421 3.16996 9.23421C3.54996 5.75171 6.48585 3.125 9.99919 3.125C12.6025 3.125 14.9493 4.60333 16.1076 6.875H13.3333C12.9883 6.875 12.7083 7.155 12.7083 7.5C12.7083 7.845 12.9883 8.125 13.3333 8.125H17.5C17.845 8.125 18.125 7.845 18.125 7.5V3.33333C18.125 2.98833 17.845 2.70833 17.5 2.70833Z",
      fill: "currentColor"
    }));
  };
});
